(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.invertEnabled = this.dataset.invertEnabled === 'true';
      this.invertOffset = parseInt(this.dataset.invertOffset, 10);
      if (isNaN(this.invertOffset)) this.invertOffset = 600;
      this.updateInvert(window.pageYOffset || document.documentElement.scrollTop);

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    updateInvert(scrollTop) {
      if (!this.invertEnabled) return;
      this.header.classList.toggle('header--inverted', scrollTop >= this.invertOffset);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      this.updateInvert(scrollTop);

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
  class RavingRoomVideoBanner extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('[data-video-banner-media]');
      this.soundToggle = this.querySelector('[data-video-banner-sound-toggle]');

      if (!this.video || !this.soundToggle) return;

      this.video.muted = true;
      this.onSoundToggle = this.toggleSound.bind(this);
      this.onVolumeChange = this.updateSoundToggle.bind(this);
      this.soundToggle.addEventListener('click', this.onSoundToggle);
      this.video.addEventListener('volumechange', this.onVolumeChange);
      this.updateSoundToggle();
    }

    disconnectedCallback() {
      this.soundToggle?.removeEventListener('click', this.onSoundToggle);
      this.video?.removeEventListener('volumechange', this.onVolumeChange);
    }

    toggleSound() {
      this.video.muted = !this.video.muted;

      if (!this.video.muted) {
        this.video.play().catch(() => {});
      }
    }

    updateSoundToggle() {
      const isMuted = this.video.muted;
      this.soundToggle.dataset.muted = String(isMuted);
      this.soundToggle.setAttribute('aria-pressed', String(!isMuted));
      this.soundToggle.setAttribute(
        'aria-label',
        isMuted ? this.soundToggle.dataset.labelMuted : this.soundToggle.dataset.labelAudible,
      );
    }
  }

  if (!customElements.get('video-banner')) {
    customElements.define('video-banner', RavingRoomVideoBanner);
  }

  } catch(e) { console.error(e); }
})();
})();
